import { useController } from 'react-hook-form';
import { UncontrolledCheckbox, UncontrolledInput } from 'components/Form';
import { defaultDetail } from './VenueDetail';

const t = {
  required: 'Required',
  no_required: 'No required',
};

const VenueBookingEditMode = ({ fieldName, booking }) => {
  const { field } = useController({
    name: `${fieldName}.isRequired`,
    defaultValue: booking?.isRequired || false,
    shouldUnregister: false,
  });

  const { field: bookingInstructionsField } = useController({
    name: `${fieldName}.instructions`,
    defaultValue: booking?.instructions ? booking.instructions : '',
    shouldUnregister: false,
  });

  const isRequired = field.value;

  return (
    <div className="field-container">
      <div className="field-bottom-margin">
        <UncontrolledCheckbox
          {...field}
          role="checkbox"
          label="Booking is required to load or unload here"
          defaultChecked={booking?.isRequired}
        />
      </div>
      {isRequired && (
        <div>
          <UncontrolledInput
            placeholder="URL of the booking site or booking email"
            {...bookingInstructionsField}
          />
        </div>
      )}
    </div>
  );
};

const VenueBookingRenderer = ({ value: booking, fieldName, isEditing }) => {
  if (isEditing) {
    return <VenueBookingEditMode fieldName={fieldName} booking={booking} />;
  }

  if (typeof booking === 'undefined') {
    return <>{defaultDetail}</>;
  }

  if (booking?.isRequired) {
    return (
      <>
        {t.required} {!!booking.instructions && `(${booking.instructions})`}
      </>
    );
  }

  return <>{t.no_required}</>;
};

export default VenueBookingRenderer;
